export default __webpack_public_path__ + "static/media/storageUnit1-afterB-480w.2c2fb982.avif";